import { render, staticRenderFns } from "./PrepareForSelfieDesktopSvg.vue?vue&type=template&id=f0ca1128&"
import script from "./PrepareForSelfieDesktopSvg.vue?vue&type=script&lang=ts&"
export * from "./PrepareForSelfieDesktopSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports